import moment from "moment";

export const addWidthParam = (url: string, width: number): string => {
  const [base, hash = ""] = url.split("#", 2);
  const [path, query = ""] = base.split("?", 2);
  const params = new URLSearchParams(query);

  params.set("width", String(width));

  const nextQuery = params.toString();
  return `${path}${nextQuery ? `?${nextQuery}` : ""}${hash ? `#${hash}` : ""}`;
};

export const addClassParam = (url: string, className: string): string => {
  const [base, hash = ""] = url.split("#", 2);
  const [path, query = ""] = base.split("?", 2);
  const params = new URLSearchParams(query);

  params.set("class", className);

  const nextQuery = params.toString();
  return `${path}${nextQuery ? `?${nextQuery}` : ""}${hash ? `#${hash}` : ""}`;
};

// Bunny archive classes bake a centered tovek.se logo + darkening. The logo is a fixed pixel size and
// Bunny never upscales, so the class must match the source: auction covers are stored ~400px wide
// (`axs`, small logo), lot photos are larger (`axl`, big logo). Sizes themselves live in the Bunny dashboard.
export const addArchivedClass = (
  url: string,
  width: number,
  kind: "cover" | "photo" = "photo"
): string =>
  addClassParam(addWidthParam(url, width), kind === "cover" ? "axs" : "axl");

export const formatPrice = (price: number) => {
    if (!price || isNaN(price)) {
        return "0 kr";
    }

    return new Intl.NumberFormat("sv-SE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(price) + " kr";
};

export const getSwedishDate = (date: Date | string | number) => {
    return parseToDate(date).toLocaleString("sv-SE", {
        timeZone: "Europe/Stockholm"
    });
};

export const parseDate = (date: string) => {
    return moment(date).valueOf();
}

export const parseToDate = (date: string | number | Date) => {
    return moment(date).toDate();
}

/**
 * Formats Swedish personal number (PNR) to correct format: YYMMDD-NNNN
 * Handles various input formats:
 * - 12 digits with century (e.g., "198912072454" -> "891207-2454")
 * - 10 digits without century (e.g., "8912072454" -> "891207-2454")
 * - Already formatted (e.g., "891207-2454" -> "891207-2454")
 */
export const formatSwedishPNR = (pnr: string): string => {
    if (!pnr) return '';

    // Remove any existing dashes or spaces
    const cleaned = pnr.replace(/[-\s]/g, '').trim();

    if (!cleaned) return '';

    // If 12 digits, it has century prefix (19 or 20) - remove it
    if (cleaned.length === 12) {
        // Remove the first 2 digits (century) and return in YYMMDD-NNNN format
        return `${cleaned.substring(2, 8)}-${cleaned.substring(8)}`;
    }

    // If 10 digits, just format as YYMMDD-NNNN
    if (cleaned.length === 10) {
        return `${cleaned.substring(0, 6)}-${cleaned.substring(6)}`;
    }

    // Return as-is if unexpected length
    return cleaned;
};
